/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { SagaIterator } from 'redux-saga';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { authenticateUserAdapter, createUserAdapter, getUserAdapter } from '../../adapters/UserAdapter';
import { storeUserDataAction } from './UserActionCreators';
import { UserActionTypes } from './UserActionTypes';
import { getTypeOfUser, initialLoginNavigation } from './UserHelpers';
import { UserModel } from './UserModel';

export function* createUserSaga(action: any): SagaIterator {
  const data = yield call(createUserAdapter, action.payload.newUser);

  if (data.status === 'ok') {
    window.location.href = '/login';
  }
}

export function* authenticateUserSaga(action: any): SagaIterator {
  const data = yield call(authenticateUserAdapter, action.payload.loginUser);

  if (data.token) {
    const userType = getTypeOfUser(data.user);

    localStorage.setItem('authToken', data.token);
    localStorage.setItem('userType', getTypeOfUser(data.user));
    localStorage.setItem('userId', data.user.id);

    // Store user data in Redux immediately
    yield put(storeUserDataAction(data.user));

    const searchParams = new URLSearchParams(window.location.search);
    const redirectUrl = searchParams.get('redirect');
    window.location.href = redirectUrl || initialLoginNavigation(userType);
  }
}

export function* getUserSaga(action: any): SagaIterator {
  const data: UserModel = yield call(getUserAdapter, action.payload);
  if (data) {
    yield put(storeUserDataAction(data));
  }
}

export function* watchUserAsyncActions(): SagaIterator {
  yield all([
    takeLatest(UserActionTypes.CREATE_USER, createUserSaga),
    takeLatest(UserActionTypes.AUTHENTICATE_USER, authenticateUserSaga),
    takeLatest(UserActionTypes.GET_USER, getUserSaga),
  ]);
}
